module.exports = __webpack_public_path__ + "media/hezuo.0d2547cc.mp3";